function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M89.72 90.33l7.67-29.94L87 50l10.39-10.39-7.67-29.94L59.78 2 49.39 12.39 39 2 9.06 9.67 1.39 39.61 11.79 50 1.39 60.39l7.67 29.94L39 98l10.39-10.39L59.78 98zm-34.39-8.66l9.9-9.9 12.59 12.6-15.76 4zM39.5 34.17l9.89-9.9 9.9 9.89-9.9 9.9zm4 15.83l-9.89 9.9-9.95-9.9 9.9-9.9zm21.78-9.9l9.84 9.9-9.89 9.9-9.9-9.9zm-5.99 25.74l-9.9 9.89-9.89-9.9 9.89-9.89zM36.72 88.4L21 84.37l12.6-12.6 9.89 9.9zm-19-32.46l9.9 9.89L15 78.43l-4-15.76zM15 21.57l12.59 12.6-9.9 9.89L11 37.33zm28.42-3.24l-9.89 9.9L21 15.63l15.75-4zm18.64-6.73l15.76 4-12.59 12.63-9.9-9.9zm19 32.46l-9.89-9.89 12.59-12.6 4 15.76zm2.7 34.37L71.17 65.84l9.89-9.9 6.73 6.73z"
});

var SvgPlaidLogo = function SvgPlaidLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaidLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plaid-logo.24147bab.svg";
export { ForwardRef as ReactComponent };